import BaseApi from '@/api/base-api'

class MerchantIbanApi extends BaseApi {
  submitIbanVerification = (dataToBeSent) => {
    return this.request(
      {
        path: `${this.uri}/iban-verification`,
        method: 'POST',
        data: dataToBeSent,
      },
      {
        options: {
          hideMessage: true,
        },
      }
    )
  }
}

export default new MerchantIbanApi('/merchants')
